export const appVersion = '4.3.91';
export const buildDate = '2025-06-25 07:59:32+00:00';
export const appSetupName='';
export const vcsLastCommit='2b2511e3ddab652206f075cd07adf8cdd7023e8e';
